module.exports = __webpack_public_path__ + "img/stop_watch.6e4d79b7.svg";